import React from 'react'
import Skeleton from 'react-loading-skeleton';
import CateogaryPostSkeleton from './CateogaryPostSkeleton';

function CateogarySkeleton() {
    let a = 0;
    return (
        <div className="w3l-homeblock2 py-5">
            <div className="container py-lg-5 py-md-4">
                <div className="left-right">
                    <Skeleton width={'8em'} height={`2em`} />
                    <Skeleton width={`4em`} height={`2em`} />
                </div>
                <div className="row">
                    {Array(3).fill().map(() => {
                        a++;
                        return <CateogaryPostSkeleton key={`CateogarySkeleton${a}`} />
                    })}
                </div>
            </div>
        </div>
    )
}

export default CateogarySkeleton
